import { v4 } from 'uuid';

import { Module } from '@entities/module';

import { Lesson, LessonContent, TOC } from '../model/types';

const flattenSections = (sections: LessonContent[]): TOC[] => {
  const traverse = (list: LessonContent[]): TOC[] => {
    const toc: TOC[] = [];

    list
      .sort((a, b) => a.order - b.order)
      .forEach((section) => {
        let childrenToc: TOC[] = [];

        if (section.children?.length) {
          childrenToc = traverse(section.children);
        }

        toc.push(
          {
            id: section.id || v4(),
            type: 'section',
            title: section.title,
            sections: undefined,
            completed: section.completed,
            locked: section.locked,
          },
          ...childrenToc,
        );
      });

    return toc;
  };

  return sections.map((section) => ({
    id: section.id || v4(),
    type: 'section-boss',
    title: section.title,
    completed: section.completed,
    locked: section.locked,
    sections: section.children?.length ? traverse(section.children) : undefined,
  }));
};

export const generateModuleWithLessonTOC = (data: Module, lesson?: Lesson): TOC[] => {
  const lessons = data.syllabus.map((l) => ({
    id: l.id || v4(),
    type: 'lesson',
    order: l.order,
    title: l.title,
    completed: l.stats.completed,
    locked: false,
  }));

  const quizzes = data.quizzes
    .filter((q) => !q.completed)
    .map((q) => ({
      id: q.id || v4(),
      type: 'quiz',
      order: q.order,
      title: q.title,
      completed: q.completed,
      failed: q.failed,
      locked: q.locked,
    }));

  const combined = [...lessons, ...quizzes].sort((a, b) => a.order - b.order);

  return combined.map((item): TOC => {
    if (item.type === 'lesson') {
      return {
        id: item.id || v4(),
        type: 'lesson',
        title: item.title,
        sections: item.id === lesson?.id ? flattenSections(lesson.sections || []) : [],
        completed: item.completed,
        locked: false,
      };
    }

    return {
      id: item.id || v4(),
      type: 'quiz',
      title: item.title,
      sections: undefined,
      completed: item.completed,
      failed: (item as TOC).failed,
      locked: item.locked,
    };
  });
};
